let contextPath = process.env.NODE_ENV === "production" ? "" : "/api";

let config = {
  title: "易博特前端开发框架",
  companyInfo: "大连易博特科技有限公司",
  version: '',
  logo: "./img/logo.png",
  embedHeader: null,
  embedHome: null, // 但页模式使用的首页
  isSinglePage: false,// 单页模式
  context: {
    protocol: window.location.protocol,
    domain: document.domain,
    port: window.location.port,
    webSocketURL: (window.location.origin).replace(/http[s]?:\/\//, 'ws://')
  },
  ajaxUrl: contextPath,
  tomeOut: 30000 * 2,
  lang: 'zh-CN',
  allowI10n: true,
  isSso: false,     //  使用统一身份认证, 设置为true后没有修改密码按钮
  prefixes: {
    sysCodeList: "code:list",
    sysCodeTree: "code:tree",
    ajax: "ajax"
  },
  respCode: {
    success: "000000",
    timeout: "000100",
    validat: "000300",
    failure: "000400"
  },

  changeLangVisible: true,                              // 国际化按钮是否可见

  logoutUrl: '',                                        //  登出后跳转地址
  loginUrl: '/anon/aces',                               //  登录地址前缀

  // ====== 登录页 start ======
  login: {
    mode: 'image',                                    // 背景模式(image/video)
    image: '/img/login_bg.jpg',                       // 图片文件路径(mode = image时显示)
    video: '/video/login_video.webm',                 // 视频文件路径(mode = video时显示)
    videoPoster: '/img/login_video_poster.png',       // 加载视频时预览图

    logoMode: 'image',                                // logo模式(text/image)
    logoText: document.title,                         // logo文字(logoMode = text时生效)
    logoImage: './img/login_left_logo.png',           // logo图片(logoMode = image时生效)
    bottomLogo: './img/login_bottom_logo.png',        // 登录页右下角logo
  },

};

export default config;
